<template>
    <b-button-group>
        <slot name="prepend" />
        <template v-if="!noDuplicate && $gate.allow('create', item.model_name)">
            <b-button
                :disabled="duplicating"
                :title="$t('Duplicate')"
                @click="$refs.duplicateModal.show()"
            >
                <fa fixed-width icon="copy" :spin="duplicating" />
                <span class="sr-only">{{ $t('Duplicate') }}</span>
            </b-button>

            <duplicate-modal
                ref="duplicateModal"
                :api-url="`${apiUrl}/${item.id}/duplicate`"
                :show-override-options="showOverrideOptions"
                :show-clone-options="showCloneOptions"
                :hide-locations="hideLocations"
                :project-id="projectId"
                @duplicated="$emit('duplicated', $event)"
                @duplicating="duplicating = $event"
            />
        </template>

        <b-button
            v-if="$gate.allow('delete', item)"
            :disabled="deleting"
            :title="$t('Delete')"
            variant="danger"
            @click="handleDelete"
        >
            <fa fixed-width icon="trash" :spin="deleting" />
            <span class="sr-only">{{ $t('Delete') }}</span>
        </b-button>

        <slot name="append" />
    </b-button-group>
</template>
<script>
    import DuplicateModal from "@/components/DuplicateModal"
    import deleteItem from "@/mixins/deleteItem";

    export default {
        name: 'ListItemButtons',
        components: {DuplicateModal},
        mixins:[deleteItem],
        props: {
            item: {
                type: Object,
                required: true
            },
            projectId: {
                type: [Number, String],
                default: null
            },
            apiUrl: {
                type: String,
                required: true
            },
            noDuplicate: {
                type: Boolean,
                default: false
            },
            hideLocations: {
                type: Boolean,
                default: false
            },
            showOverrideOptions: {
                type: Boolean,
                default: false
            },
            showCloneOptions: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                duplicating: false,
            }
        },
        computed: {
            deleteApiUrl() {
                return this.apiUrl + '/' + this.item.id
            },

            resourceName() {
                //TODO change it after routing refactor
                return '';
            }
        }
    }
</script>
